import React, { memo } from 'react'
import { useReadContract } from 'wagmi'

import BaseCard from '../shared/baseCard/BaseCard'
import DisplayStats from './DisplayStats'
import {
  formatAmount,
  formatCurrency,
  formatCurrencyShort
} from '../../util/numbers.helpers'
import { tokenAbi } from '../../abis/tokenAbi'
import { getContractsAddresses } from '../../util/claim.helpers'

const Wallet = ({ t, address }) => {
  const { data } = useReadContract({
    address: getContractsAddresses()?.token,
    abi: tokenAbi,
    functionName: 'balanceOf',
    args: [address],
    watch: true
  })
  const balance = formatAmount(data)
  return (
    <BaseCard sx={{ p: 3 }}>
      <DisplayStats
        data={[
          {
            label: t('staking.your-wallet-balance'),
            value: formatCurrencyShort(balance),
            helpText: formatCurrency(balance)
          }
        ]}
        gridSize={12}
        sx={{ textAlign: 'right' }}
      />
    </BaseCard>
  )
}

export default memo(Wallet)
